import React from 'react';
import Dialog from 'react-modal';
import { FormattedMessage } from 'react-intl';
import { Icon } from '@doxyme/ui';
import { is } from 'ramda';
import './modal.sass';
export const getCustomStyles = (styles) => {
    const { top = '50%', left = '50%', right = 'auto', bottom = 'auto', marginRight = '-50%', border = 'none', transform = 'translate(-50%, -50%)', padding = '20px', boxShadow = 'none', displayOverlay = 'block', opacityOverlay = '.8', } = !!styles && styles;
    return {
        content: {
            top,
            left,
            right,
            bottom,
            marginRight,
            border,
            transform,
            borderRadius: '4px',
            zIndex: 20,
            padding,
            boxShadow
        },
        overlay: {
            background: `rgba(0,0,0, ${opacityOverlay})`,
            zIndex: 1000,
            display: displayOverlay,
        }
    };
};
export const Modal = ({ onClose, children, styles, title, showCloseBtn = true, ...rest }) => {
    const { minWidth = '', maxWidth = '', height = '', } = !!styles && styles;
    return (<Dialog onRequestClose={onClose} style={getCustomStyles(styles)} ariaHideApp={false} {...rest}>
      {is(String, title) ? (<p className="Modal__title">
          <FormattedMessage id={title}/>
        </p>) : (<p className="Modal__title">{title}</p>)}
      {showCloseBtn && (<button className="Modal__close" onClick={onClose}>
          <Icon name="close" size="x-small"/>
        </button>)}
      <div className="Modal__wrapper" style={{
            minWidth,
            maxWidth,
            height,
        }}>
        {children}
      </div>
    </Dialog>);
};
